import { ActionNotSubmitted } from '../general/helpers/serverActions';

export { CARMA_PHONE_NUMBER, CARMA_WHATSAPP } from '@repo/constants';

export const GENERIC_ERROR_MESSAGE = 'An unknown error happened, please try again later.';

export const CARMA_PHONE_NUMBER_PRETTY = '02 8319 3210';
export const CARMA_TEXT_NUMBER = '+61485854551';
export const CARMA_TEXT_NUMBER_PRETTY = '0485 854 551';

export const CAR_TRANSFER_FEE_NSW = 42;
export const PLATE_TRANSFER_FEE = 32;

export const MAX_VEHICLE_YEAR = new Date().getFullYear();
export const MIN_VEHICLE_YEAR = 1975;

export type CAR_PURCHASE_STATUS = 'available' | 'draftOrder' | 'reserved' | 'purchased' | 'delivered';

export const TIMEZONE_NAME = 'AEDT';

export const CARD_PAYMENT_AUTHORISED = 'Authorised';

export type AustralianState = 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA';
export const AUSTRALIAN_STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'] as const;

export const POLLING_TIMEOUT_MILLISECONDS = 45 * 1000;

/** max number of SKU to cap the recently viewed cars results to */
export const RECENTLY_VIEWED_MAX_SKUS = 13;

/** Length of the phone verification pin */
export const PHONE_PIN_LENGTH = 4;
/** Minimum duration required to request OTP again in seconds*/
export const TIMER_LENGTH = 30;

export const enum ContentfulEntryId {
  FINANCE_CALCULATOR_SECTION_ID = '3Mut2215Rv5cENFMm4xOEG',
  HEADER_NAV_SECTION_ID = '1xX3QuYEMRSwCJHsUnDaVu',
  INVESTOR_HEADER_NAV_SECTION_ID = '6lhBugRQIhLAGijOUBrvHW',
}

/** Form field name to pass recaptcha token */
export const RECAPTCHA_FIELD_NAME = 'recaptchaToken';

/**
 * Query param name to indicate we are post SSO authentication
 * Used by middleware to skip UTM cookie serialisation
 */
export const POST_SSO_PARAM = 'postSso';

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export const SERVER_ACTION_NOT_SUBMITTED: ActionNotSubmitted = { status: 'initial' };

export const TRADE_IN_PAGE_PATH = '/sell-or-trade-in-my-car';
export const TRADE_IN_FORM_PATH = '/forms/-/trade-in-enquiry';
export const BOOKING_FORM_PATH = '/forms/-/booking';
export const CHECKOUT_PATH = '/forms/-/checkout';
export const CHECKOUT_EXPIRED_PATH = `${CHECKOUT_PATH}/expired`;
export const AUTH_FORM_PATH = '/forms/-/auth';
export const AUTH_FORM_START_PATH = '/forms/-/auth/start';
export const AUTH_FORM_PHONE_VERIFY_PATH = '/forms/-/auth/phone-verify';
export const DEFAULT_AUTH_FORM_COOKIE = {
  display_state: 'default',
  redirect_url: '/',
  origin: '/',
};

export const PDP_PATH = '/product-detail';

/** Maximum number of cars to be compared */
export const CAR_COMPARISON_MAX = 2;

export const PDP_PRICE_CARD_ID = 'priceCard';

export type CarGalleryNavigation = 'exterior' | 'interior' | 'open' | 'gallery' | 'imperfections';

export const MAX_INT = 2147483647;

export const MAX_MANUFACTURER_WARRANTY_MONTHS_WARNING = 24;

export const SEO_TITLE_LENGTH = 60;

export const SEARCH_POPOVER_BUTTON_ID = 'search-popover-button';

/**
 * Max length for SKU validation
 *
 * Currently SKU length is 6 so 10 should be safe for the foreseeable future.
 */
export const MAX_SKU_LENGTH = 10;

export const REQUEST_INSPECTION_PREFERRED_TIMES = [
  'Mornings',
  'Middle of the day',
  'Afternoons',
  'Evenings',
  'Any time',
] as const;

export const OFFER_VALID_TIME_IN_DAYS = 7;
// Default values should be coming from Contentful settings in the future

export const seoDefault = {
  title: 'Carma | The easy way to buy used cars in Australia',
  description: 'Carma | The easy way to buy used cars in Australia',
  socialImage: '',
};

export const seoDefault404 = {
  title: '404 Page Not Found | Carma',
  description: 'Whoops, looks like this page is missing',
  socialImage: '',
};

export const seoDefaultError = {
  title: 'Carma | Something went wrong',
  description: 'Oops, looks like something went wrong',
  socialImage: '',
};

export const seoDefaultPlp = {
  title: 'Used Cars | Buy Used Cars Online Australia | Carma',
  description:
    'Find the best used cars from top brands available today to buy or finance with free delivery to your door in Sydney. All Carma used cars are fully inspected and reconditioned by experts and come with seven day return and three months warranty. Buy your next car online at Carma.',
  socialImage: '',
};

export const DOCUMENT_UPLOAD_MAX_FILE_SIZE_IN_BYTES = 20 * 1024 * 1024; // 20MB
export const CONCEPT_ID_MARKETING_TILE_PLP = '5Rrtbccp0fu8sCYbDlbg5C';
export const CONCEPT_ID_MARKETING_TILE_SIMILAR = '1kXOyxmr8tiKyXyRtGqZ0o';

export const enum YES_NO_OPTION {
  YES_OPTION = 'yes',
  NO_OPTION = 'no',
}
export const yesNoOptions = [
  {
    value: YES_NO_OPTION.YES_OPTION,
    label: 'Yes',
  },
  {
    value: YES_NO_OPTION.NO_OPTION,
    label: 'No',
  },
];
